// 根据权限菜单路由获取
import {permissionSwitch} from '@/settings'
import Layout from '@/layout/layout.vue'
import LayoutFull from '@/layout/layoutFull.vue'
import LayoutSite from '@/layout/layoutSite.vue'
import ParentView from '@/layout/parentView.vue'
import IframeView from '@/layout/iframeView.vue'
import {getMenuRouteList} from "@/api/auth.api.js"
import {concatPath, listToMap, listToTree, treeToList} from "@/utils/util.js"
import {getCachedView, setCachedView} from "@/utils/auth.js"

import menuRouteList from "@/api/routeConfig";

const menuRoute = {
  state: {
    // 路由，不完全和菜单一致，比如存在新开窗口的本地页面的菜单，那么需要提升到M层
    // 比如一个C配置：其他默认，path=dev, redirect=dev/index, meta={link:true, linkType: blank}
    routes: [],
    // 菜单结构
    menuRoutes: [],
    sidebarMenuRoutes: [],// 侧边栏菜单（根据menuRoutes的选择实时变化）
    // menuRoutes的Map存储，/path映射到menu对象
    menuCopyRoutes: {},

    // 侧边栏最后一次被激活菜单（一个topNav最后一次只有一个）
    // {"/":{path:"/home"}, "/sys": {path:"/sys/menu"}, "/product": {path:"/product/contract/info"}, "/risk":{path:"XXX"}}
    lastActiveMenuPath: {},
    // 缓存的路由name
    cachedViews: getCachedView() || [],
    permissions: [], // 用户权限，按钮等元素权限
  },
  mutations: {
    setRoutes: (state, routes) => {
      state.routes = routes;
    },
    setMenuRoutes: (state, menuRoutes) => {
      state.menuRoutes = menuRoutes;
    },
    setMenuCopyRoutes: (state, menuCopyRoutes) => {
      state.menuCopyRoutes = menuCopyRoutes;
    },
    setSidebarMenuRoutes: (state, sidebarMenuRoutes) => {
      state.sidebarMenuRoutes = sidebarMenuRoutes;
    },
    setLastActiveMenuPath: (state, lastActiveMenuPath) => {
      state.lastActiveMenuPath = lastActiveMenuPath;
    },
    addCachedViews: (state, view) => {
      if (!view || !view.name) return;
      if (state.cachedViews.includes(view.name)) return
      if (view.meta && view.meta.cache) {
        state.cachedViews.push(view.name)
        setCachedView(state.cachedViews)
      }
    },
    delCachedViews: (state, view) => {
      if (!view || !view.name) return;
      let index = state.cachedViews.indexOf(view.name)
      if (index > -1) {
        state.cachedViews.splice(index, 1)
        setCachedView(state.cachedViews)
      }
    },
    setPermissions: (state, permissions) => {
      state.permissions = permissions
    },
  },
  actions: {

    doAddCachedView({commit, state}, view) {
      return new Promise(resolve => {
        commit('addCachedViews', view)
        resolve([...state.cachedViews])
      })
    },

    doDelCachedView({commit, state}, view) {
      return new Promise(resolve => {
        commit('delCachedViews', view)
        resolve([...state.cachedViews])
      })
    },


    /**
     * 保存对于topNav菜单的最后一次被激活的子菜单
     * @param commit
     * @param state
     * @param lastActiveMap
     */
    doLastActiveMenuPath({commit, state}, lastActiveMap) {
      let lastActiveMenuPathJson = state.lastActiveMenuPath;
      lastActiveMenuPathJson[lastActiveMap.topNavKey] = lastActiveMenuPathJson[lastActiveMap.topNavKey] || {};
      lastActiveMenuPathJson[lastActiveMap.topNavKey].path = lastActiveMap.lastActiveMenuKey;
      if (lastActiveMap.lastActiveMenuQuery) {
        lastActiveMenuPathJson[lastActiveMap.topNavKey].query = lastActiveMap.lastActiveMenuQuery;
      }
      commit('setLastActiveMenuPath', lastActiveMenuPathJson);
    },
    /**
     * 生成路由
     * @param commit
     */
    doGenMenuRouteList({commit}) {
      return new Promise((resolve, reject) => {
        // 调用接口
        getMenuRouteList().then(resp => {
          let respMenuData = resp.data || []
          respMenuData = menuRouteList.concat(respMenuData)
          // ///////////////// 按钮等元素权限 //////////////////////////
          let fList = [] // F
          let mList = [] // MCV
          // 过滤出F
          respMenuData.forEach(item => {
            if (item.meta && item.meta.menuType == 'F') {
              if (item.meta.permission && !item.meta.hidden) {//有
                fList.push(item.meta.permission)
              }
            } else {
              mList.push(item)
            }
          })
          // 不开启权限控制，则默认全部权限
          if (!permissionSwitch) {
            fList = ["*:*:*"]
          }
          commit('setPermissions', fList)

          // ///////////////// 按钮等元素权限 //////////////////////////

          // debugger
          let str = JSON.stringify(mList);
          let strRouteData = str;
          let strMenuData = str;

          // 处理路由结构
          let routeData = JSON.parse(strRouteData);
          routeData = listToTree(improveRouter(routeData));
          let routes = filterAsyncRouter(routeData);
          commit('setRoutes', routes);

          // 处理成菜单结构
          let menuData = listToTree(JSON.parse(strMenuData));
          let menuRoutes = filterAsyncMenu({}, menuData);
          commit('setMenuRoutes', menuRoutes);

          // 转换成[{path:{path, parentPath, id, name,},{path:{path, parentPath, id, name,}]
          let menuCopyRoutes = listToMap(treeToList(menuRoutes), {idField: 'path'})
          commit('setMenuCopyRoutes', menuCopyRoutes);

          console.log("======>routes", routes)
          console.log("======>menuRoutes", menuRoutes)
          console.log("======>setMenuCopyRoutes", menuCopyRoutes)
          console.log("======>permissions", fList)
          resolve(routes);
        }).catch(err => {
          reject(err)
        });
      });
    }
  }
}

/**
 * 如果出现配置菜单需要提升，则做路由提升处理，但是菜单不处理
 * @param routes
 */
function improveRouter(routes) {
  return routes.map(item => {
    // 如果出现，菜单link=true，linkType=blank，且不是同一个Layout，则需要提升一级菜单
    if (item.meta.menuType === 'C') {// 如果是菜单，设置默认值
      // if (item.meta.link && item.meta.linkType === 'blank' && item.component === 'LayoutFull') {
      if (item.openType == '2' && item.component === 'LayoutFull') {
        item.parentId = 0;// 挂在根及目录下，相当于路由从跟开始拼接，而不是原先拼接，因为不修改会使用父级layout
        console.log("========improveRouter=====", item)
      }
    }
    return item
  });
}

/**
 * 过滤处理路由的 component
 * {
 *    id: 20010, parentId: 200, title: "接口文档", name: "ViewMenuApiDoc", component: "",
 *    path: "apiDoc", redirect: 'http://localhost:19920/doc.html',openType: 1,
 *    meta: {menuType: 'C', cache: false, hidden: false},
 *  },
 * {
 *    id: 20020, parentId: 200, title: "设计文档", name: "ViewMenuDesignDoc", component: "Layout",
 *    path: "design", redirect: 'design/index',openType: 0,
 *    meta: {menuType: 'C', cache: false, hidden: false},
 *  },
 * @param routes 菜单表记录
 * @return 路由记录 {id,name,path,redirect,component,parentId, query,params,fullPath,meta}
 */
function filterAsyncRouter(routes) {
  return routes.map(item => {
    item.path = item.path || '';
    if (!item.component) {// 没有配置则都是页面
      item.component = 'ParentView';
    }
    // ===================================
    // 菜单配置默认数据补全（S）
    // ===================================

    // 一级目录，作为菜单打开，比如首页
    // meta={menuType: 'C'},component: "Layout"，C下面的V配置不变
    //
    // ====== openType ====
    // 0-内部打开路由（默认）
    // 1-内部打开url（一般指嵌入）
    // 3-外部打开路由（大屏设计等，根据Layout选择可以包含侧边栏等场景）
    // 4-外部打开url（指在菜单跳转到外部，eg：swagger地址）

    // 装载component
    // if (item.component === 'Iframe' || (item.meta.link && item.meta.linkType !== 'blank')) {
    if (item.openType == '1') {// 内部打开外链
      item.component = IframeView
      if (item.meta.menuType === 'C') {
        // 如果是菜单，需要构建Iframe的src参数
        item.query = {src: item.redirect, authentication: item.meta.authentication, key: item.meta.key};
        item.redirect = null;
      }
    } else if (item.component === 'LayoutFull') {// 外部打开内页面（无侧边，eg:设计大屏）
      item.component = LayoutFull
    } else if (item.component === 'LayoutSite') {// 无侧边栏的页面（无侧边，eg:首页）
      item.component = LayoutSite
    } else if (item.component === 'Layout') {// 正常窗口（导航+侧边）
      item.component = Layout
    } else if (item.component === 'ParentView') {// 二级菜单就是一个空的路由
      item.component = ParentView
    } else {
      item.component = loadView(item.component)// 页面
    }

    // ===================================
    // 菜单和页面拆开，菜单配置默认数据补全（E）
    // ===================================

    // 递归处理子节点
    if (item.children && item.children.length) {
      item.children = filterAsyncRouter(item.children)
    } else {
      delete item['children']
    }
    return item
  });
}

/**
 * 查找需要绑定到菜单上的页面，服务端返回的sort排序第一个，作为菜单打开的页面
 *
 * @param path
 * @param children
 * @returns {null|*}
 */
function findFirstBindView({path, children}) {
  if (children && children.length > 0) {
    return children.find(item => (item.meta.menuType === 'V'));
  }
  return null;
}

/**
 * 加载view对象
 *
 * @param viewPath
 * @returns {function(): *}
 */
function loadView(viewPath) {
  if (viewPath) {
    if (viewPath.substr(0, 1) !== '/') {
      viewPath = '/' + viewPath;
    }
    return () => Promise.resolve(require(`@/views${viewPath}`).default);
  } else {
    return null;
  }
}

/**
 * 处理路由菜单，拼接path，并且删除路由中不用的字段（component，只保留菜单用的字段）
 * [{name, path, meta, grade, children}]
 *
 *
 * @param parent
 * @param routes
 */
function filterAsyncMenu(parent, routes) {
  let menuRouteList = [];
  routes.map(item => {
    // 只有目录和菜单才能进入(页面也进来，但是在菜单render时候，判断hidden和v的不显示)
    if (item.meta.menuType !== 'M' && item.meta.menuType !== 'C' && item.meta.menuType !== 'V') {
      return;
    }
    // 隐藏菜单不显示，编辑，新增等路由
    if ((item.meta.menuType === 'M' || item.meta.menuType === 'C') && item.meta.hidden) {
      return;
    }
    item.path = item.path || '';

    // 一级菜单，有了几级菜单，可以针对性设置css样式
    let grade = 1
    if (parent.grade) {
      grade = parent.grade + 1
    }

    item.grade = grade;
    item.parentPath = '';// 新增一个parentPath

    // 如果是内部打开链接
    if (item.openType == '1') {
      item.query = {src: item.redirect, authentication: item.meta.authentication, key: item.meta.key};
      item.redirect = null;
    }
    // 拼接父类路由path + 自己路由path
    if (item.path.charAt(0) !== '/') {
      item.path = concatPath(parent.path, item.path);
      item.parentPath = parent.path;
    }
    // 页面的话不处理【拼接父类路由path + 自己路由path】
    // 目录/菜单的话，可能有子节点，递归处理子节点
    if (item.children && item.children.length) {
      // 递归处理子节点
      item.children = filterAsyncMenu(item, item.children)
    }
    menuRouteList.push(item);
  });
  return menuRouteList;
}

export default menuRoute


